module.exports = "https://www.gc-qa.gnp.com.mx/87f2d809102c14b4337236a43eb29b51.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/twitter.png
// module id = 8168
// module chunks = 0